import IconButton from '@mui/material/IconButton';
import { useSelector } from 'react-redux';
import FuseSearch from '@fuse/core/FuseSearch';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import { selectFlatNavigation } from 'app/store/fuse/navigationSlice';

const defaultSearchTrigger = (
  <IconButton className="w-40 h-40" size="large">
    <FuseSvgIcon>heroicons-outline:search</FuseSvgIcon>
  </IconButton>
);

function NavigationSearch(props) {
  const { variant, className, trigger = defaultSearchTrigger } = props;
  const navigation = useSelector(selectFlatNavigation);

  return (
    <FuseSearch
      className={className}
      variant={variant}
      navigation={navigation}
      trigger={trigger}
    />
  );
}

export default NavigationSearch;
